export const DEFAULT_LOCATION = { lat: 40.706005, lng: -74.008827 }; // NEW YORK

export const mapPinSrc = "data:image/svg+xml;base64," + window.btoa(`
  <svg width="56" height="66" viewBox="0 0 56 66" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_407_181954)">
      <path d="M42.3669 10.6582C34.4326 2.72395 21.5686 2.72395 13.6343 10.6582C5.70002 18.5925 5.70002 31.4566 13.6343
        39.3908C14.3246 40.0811 15.1816 40.9288 16.2053 41.9341L24.3512 49.8578C25.3687 50.8418 28.0006 52.9998 28.0006
        52.9998C28.0006 52.9998 30.6327 50.8423 31.6503 49.8584C34.9073 46.7093 37.5559 44.1335 39.5973 42.1299L42.3669
        39.3908C50.3012 31.4566 50.3012 18.5925 42.3669 10.6582Z" fill="#8B54FF"/>
    </g>
    <circle cx="28" cy="25.6665" r="7" fill="white"/>
    <defs>
      <filter
        id="filter0_d_407_181954"
        x="2.82459"
        y="4.38642"
        width="52.984"
        height="60.6425"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"/>
        <feOffset dx="1.31599" dy="5.8539"/>
        <feGaussianBlur stdDeviation="3.0875"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.255 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_407_181954"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_407_181954" result="shape"/>
      </filter>
    </defs>
  </svg>
`);

export const mapDeliveryPinSrc = "data:image/svg+xml;base64," + window.btoa(`
  <svg width="49" height="50" viewBox="0 0 49 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_407_181321)">
      <circle cx="24.4976" cy="25.1734" r="24.4507" fill="#8B54FF"/>
      <path fill-rule="evenodd" clip-rule="evenodd" 
        d="M26.5371 18.042H16.3493C15.7867 18.042 15.3305 18.4981 15.3305 19.0607V22.1171H13.293V19.0607C13.293 17.3728
        14.6613 16.0044 16.3493 16.0044H26.5371C28.2251 16.0044 29.5934 17.3728 29.5934 19.0607V20.0795H31.0111C32.0649
        20.0795 33.0443 20.6224 33.6028 21.516L35.2415 24.1379C35.5451 24.6237 35.7061 25.185 35.7061 
        25.7578V29.2485C35.7061
        30.9365 34.3377 32.3049 32.6498 32.3049H32.4759C32.0563 33.4919 30.9242 34.3424 29.5934 34.3424C28.2627 34.3424
        27.1306 33.4919 26.711 32.3049H22.2881C21.8685 33.4919 20.7364 34.3424 19.4056 34.3424C18.0749 34.3424 16.9428
        33.4919
        16.5232 32.3049H16.3493C14.6613 32.3049 13.293 30.9365 13.293 29.2485V24.1546H26.5371C27.0998 24.1546 27.5559
        23.6985
        27.5559 23.1358V19.0607C27.5559 18.4981 27.0998 18.042 26.5371 18.042ZM29.5934 22.1171V23.1358C29.5934 24.8238
        28.2251
        26.1922 26.5371 26.1922H15.3305V29.2485C15.3305 29.8112 15.7867 30.2673 16.3493 30.2673H16.5232C16.9428 29.0802
        18.0749
        28.2297 19.4056 28.2297C20.7364 28.2297 21.8685 29.0802 22.2881 30.2673H26.711C27.1306 29.0802 28.2627 28.2297
        29.5934
        28.2297C30.9242 28.2297 32.0563 29.0802 32.4759 30.2673H32.6498C33.2124 30.2673 33.6686 29.8112 33.6686
        29.2485V25.7578C33.6686
        25.5668 33.6149 25.3797 33.5137 25.2178L31.875 22.5959C31.6888 22.298 31.3623 22.1171 31.0111
        22.1171H29.5934ZM30.9178
        31.2861C30.9178 32.0175 30.3249 32.6105 29.5934 32.6105C28.862 32.6105 28.269 32.0175 28.269 31.2861C28.269
        30.5546 28.862
        29.9617 29.5934 29.9617C30.3249 29.9617 30.9178 30.5546 30.9178 31.2861ZM19.4056 32.6105C20.1371 32.6105
        20.7301 32.0175
        20.7301 31.2861C20.7301 30.5546 20.1371 29.9617 19.4056 29.9617C18.6742 29.9617 18.0812 30.5546 18.0812
        31.2861C18.0812
        32.0175 18.6742 32.6105 19.4056 32.6105Z" fill="white"/>
    </g>
    <defs>
      <clipPath id="clip0_407_181321">
        <rect width="48.9014" height="48.9014" fill="white" transform="translate(0.046875 0.722656)"/>
      </clipPath>
    </defs>
  </svg>
`);
